<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <edit-form
        :disabled="disabled"
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew && !disabled"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import TabEditorWrap from '../TabEditorWrap'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapperAutoSave, FormWrapper, TabEditorWrap],
  components: {
    'edit-form': () => import(/* webpackChunkName: 'Companies' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    companyID: { required: true },
    companyName: { required: true }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'NonConformityAnalyzes/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      let title = []
      if (this.formData.findingDate) {
        let date = this.$moment(this.formData.findingDate).format('DD/MM/YYYY')
        title.push(date)
      }
      if (this.companyName) {
        title.push(this.companyName)
      }
      return title.join(' - ') || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    },
    formModel () {
      return {
        id: '',
        findingDate: '',
        writtenbyEmployeeID: null,

        nonConformityNatureID: null,
        nonConformityNatureID2: null,
        nonConformityOriginID: null,

        nonConformityDysfunctionID: null,
        nonConformityDysfunctionDetailID: null,

        analyzeDescription: '',

        nonConformityActionID: null,
        originDysfunctionCompanyID: null,
        verificationDate: null,

        propositionDaction: '',

        actionResults: '',
        actionResultsDate: null,

        employeeInchargeID: null,
        employeeSignatureRQID: null,
        done: false,
        immediateProvisions: false,
        graveOrNonGrave: false
      }
    }
  }
}
</script>

<style lang="stylus">
</style>
